import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, map, Observable, of } from 'rxjs';
import { Asset } from '../models/types/Rule/Asset.type';

@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  private readonly apiUrl = `${environment.apiUrl}/Assets`;

  private _assets: Asset = new Map();

  constructor(
    private readonly http: HttpClient
  ) { }

  //TODO: Valutare se implementare logica di chaching e relativa compressione dei dati (lz-string npm)

  getAsset(assetId: number): Observable<string | undefined> {
    if (this._assets.has(assetId)) {
      return of(this._assets.get(assetId));
    } else {
      return this.retrieveAsset(assetId).pipe(
        map(asset => {
          asset = `data:image/png;base64,${asset}`;
          this._assets.set(assetId, asset);
          return asset;
        }),
        catchError(e => {
          console.error(e);
          return of(undefined);
        })
      )
    }
  }

  retrieveAsset(assetId: number): Observable<string> {
    const url = `${this.apiUrl}/${assetId}`;
    const headers = new HttpHeaders({
      'Accept': 'text/plain',
      'Content-Type': 'application/json'
    });
    return (this.http.get(url, {
      headers,
      responseType: 'text'
    }) as Observable<string>);
  }

}
